export const copyToClipboard = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
      return true;
    } catch (err) {
      // Fallback for older browsers
      console.warn('Clipboard API not available, using fallback:', err.message);
      const textArea = document.createElement('textarea');
      textArea.value = text;
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      try {
        document.execCommand('copy');
        return true;
      } catch (fallbackErr) {
        console.error('Failed to copy text: ', fallbackErr);
        return false;
      } finally {
        document.body.removeChild(textArea);
      }
    }
  };
  
  export const showCopyFeedback = (element) => {
    const originalText = element.textContent;
    element.textContent = 'Copied!';
    element.style.color = '#10b981';
    
    setTimeout(() => {
      element.textContent = originalText;
      element.style.color = '';
    }, 2000);
  };